import React from "react"
import DropdownRHF from "components/RHF/DropdownRHF"
import InputRHF from "components/RHF/InputRHF"
import SelectRHF from "components/RHF/SelectRHF"
import { useFormContext } from "react-hook-form"
import { Button } from "reactstrap"
import {
  field_options,
  operator_options,
  status_options,
} from "constants/select-options"
import { t } from "i18next"
import PropTypes from "prop-types"

function ConditionField({ idx, removeCondition }) {
  const { watch, control } = useFormContext()
  const filed_value = watch(`group.conditions.${idx}.type`)

  return (
    <div className="d-flex flex-wrap gap-2 justify-content-between align-items-center">
      <div className="flex-grow-0 w-xl">
        <SelectRHF
          name={`group.conditions.${idx}.type`}
          control={control}
          options={field_options}
          placeholder={t("select")}
        />
      </div>
      {filed_value ? (
        <>
          <div className="mb-3">
            <DropdownRHF
              name={`group.conditions.${idx}.expression`}
              control={control}
              placeholder="select operator"
              btnClass="btn-sm"
              className="d-flex justify-content-center"
              options={filed_value ? operator_options[filed_value] : []}
            />
          </div>
          <div className="flex-grow-1">
            {filed_value === "status" ? (
              <SelectRHF
                name={`group.conditions.${idx}.value`}
                control={control}
                options={status_options}
              />
            ) : (
              <InputRHF
                name={`group.conditions.${idx}.value`}
                control={control}
              />
            )}
          </div>
        </>
      ) : null}

      <Button
        type="button"
        color="soft-danger mb-3"
        onClick={() => removeCondition(idx)}
      >
        <i className="bx bx-trash"></i>
      </Button>
    </div>
  )
}
ConditionField.propTypes = {
  idx: PropTypes.number.isRequired,
  removeCondition: PropTypes.func.isRequired,
}
export default ConditionField
